export const environment = {
  production: true,
  apiUrl: 'https://oldapi.publishwide.com/api/v1/',
  facebookRedirectUri: 'https://oldreports.publishwide.com/',
  domain: 'publishwide.com',
  stripePublicKey: 'pk_live_r3UP87LlrX7Z907GNzsP8cRR',
  wssHost: 'wss://ws.publishwide.com'
};
